import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSchool, faChalkboardUser } from "@fortawesome/free-solid-svg-icons";
import { useIntl } from "react-intl";

export default function FinalExamSourceIcon({
  isFromAnotherSchool,
  isFromAnotherClass,
}) {
  const intl = useIntl();

  if (!isFromAnotherSchool && !isFromAnotherClass) {
    return (
      <span className="me-1 invisible" aria-hidden="true">
        <FontAwesomeIcon icon={faSchool} className="exam-icon" />
      </span>
    );
  }

  const { icon, messageId } = isFromAnotherSchool
    ? { icon: faSchool, messageId: "DoneAtAnotherSchool" }
    : { icon: faChalkboardUser, messageId: "DoneInAnotherClass" };
  const label = intl.formatMessage({ id: messageId });

  return (
    <span className="me-1" role="img" aria-label={label} title={label}>
      <FontAwesomeIcon icon={icon} className="exam-icon text-primary" />
    </span>
  );
}
